import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading, SecondaryButton } from './ui/UI';
const jobs = ['Collect signals', 'Observe controls', 'Run validation', 'Create remediation', 'Store evidence'];
const categories = ['Cloud', 'Identity', 'Code', 'EDR/XDR', 'SIEM', 'SOAR', 'WAF', 'Ticketing', 'AI apps', 'Threat intelligence', 'MSSP systems'];
export function Integrations() {
  return <section className="relative w-full py-32 border-t border-white/5" data-id="element-972">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-973">
        <SectionLabel number="05" label="Signal Fabric" className="mb-8" data-id="element-974" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-975">
          <div className="lg:col-span-7" data-id="element-976">
            <SectionHeading size="xl" data-id="element-977">
              Connects to the stack
              <br data-id="element-978" />
              <span className="text-white/40" data-id="element-979">you already bought.</span>
            </SectionHeading>
          </div>
          <div className="lg:col-span-5 lg:pt-4" data-id="element-980">
            <p className="text-lg text-white/60 leading-relaxed mb-6" data-id="element-981">
              Periscan uses your existing tools as sensors, controls, evidence
              sources, and remediation paths.
            </p>
            <SecondaryButton href="/integrations" size="md" data-id="element-982">
              View Integrations
            </SecondaryButton>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-0 mb-16" data-id="element-983">
          {jobs.map((job, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: i * 0.04
        }} className="flex items-center gap-6 py-5 border-b border-white/5" data-id="element-984">
              <span className="font-mono text-xs text-[#1a8fd4]/60" data-id="element-985">
                {String(i + 1).padStart(2, '0')}
              </span>
              <span className="text-base text-white font-medium" data-id="element-986">{job}</span>
            </motion.div>)}
        </div>

        <div className="max-w-3xl" data-id="element-987">
          <p className="font-mono text-xs text-white/40 leading-relaxed uppercase tracking-widest" data-id="element-988">
            {categories.join(', ')}
          </p>
        </div>
      </div>
    </section>;
}